import { FILTER_FEATURE } from "api/ApiPath";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { CarrierListRequestModel } from "./model/carrierList/CarrierListRequestModel";
import { CarrierListResponseModel } from "./model/carrierList/CarrierListResponseModel";
import { NationListRequestModel } from "./model/nationList/NationListRequestModel";
import { NationListResponseModel } from "./model/nationList/NationListResponseModel";
import { NumberTypeListRequestModel } from "./model/numberTypeList/NumberTypeListRequestModel";
import { NumberTypeListResponseModel } from "./model/numberTypeList/NumberTypeListResponseModel";
import { PackageListRequestModel } from "./model/packageList/PackageListRequestModel";
import { PackageListResponseModel } from "./model/packageList/PackageListResponseModel";
import { ServiceListRequestModel } from "./model/serviceList/ServiceListRequestModel";
import { ServiceListResponseModel } from "./model/serviceList/ServiceListResponseModel";

export interface IFilterFeatureRepository {
  getCarrierList(
    params: CarrierListRequestModel
  ): Promise<ListBaseApiResponseModel<CarrierListResponseModel>>;
  getPackageList(
    params: PackageListRequestModel
  ): Promise<ListBaseApiResponseModel<PackageListResponseModel>>;
  getServiceList(
    params: ServiceListRequestModel
  ): Promise<ListBaseApiResponseModel<ServiceListResponseModel>>;
  getNationList(
    params: NationListRequestModel
  ): Promise<ListBaseApiResponseModel<NationListResponseModel>>;
  getNumberTypeList(
    params: NumberTypeListRequestModel
  ): Promise<ListBaseApiResponseModel<NumberTypeListResponseModel>>;
}

@injectable()
export class FilterFeatureImpl implements IFilterFeatureRepository {
  async getCarrierList(
    params: CarrierListRequestModel
  ): Promise<ListBaseApiResponseModel<CarrierListResponseModel>> {
    return await client?.get(FILTER_FEATURE.CARRIER_LIST, params);
  }

  async getPackageList(
    params: PackageListRequestModel
  ): Promise<ListBaseApiResponseModel<PackageListResponseModel>> {
    return await client?.get(FILTER_FEATURE.PACKAGE_LIST, {
      ...params,
      order: "price ASC",
    });
  }

  async getServiceList(
    params: ServiceListRequestModel
  ): Promise<ListBaseApiResponseModel<ServiceListResponseModel>> {
    return await client?.get(FILTER_FEATURE.SERVICE_LIST, params);
  }

  async getNationList(
    params: NationListRequestModel
  ): Promise<ListBaseApiResponseModel<NationListResponseModel>> {
    return await client?.get(FILTER_FEATURE.NATION_LIST, params);
  }

  async getNumberTypeList(
    params: NumberTypeListRequestModel
  ): Promise<ListBaseApiResponseModel<NumberTypeListResponseModel>> {
    return await client?.get(FILTER_FEATURE.NUMER_TYPE_LIST, params);
  }
}
